import { Calendar, ChevronDown } from '@/components/icons'
import { NativeSelectOverlay } from '@/components/ui/native-select-overlay'
import { Pill } from '@/components/ui/pill'
import { cn } from '@/components/ui/utils'
import type { FlightStatsPeriod } from '@@api/flightLog.shared'

export const statsPeriodOptions: readonly { value: FlightStatsPeriod; label: string }[] = [
  { value: 'allTime', label: 'All Time' },
  { value: 'thisYear', label: 'This Year' },
  { value: 'thisMonth', label: 'This Month' },
]

interface StatsPeriodSelectProps {
  value: FlightStatsPeriod
  onChange: (period: FlightStatsPeriod) => void
  className?: string
}

/**
 * Pill-shaped native select that picks the period the profile-card flight
 * stats cover (all time / this year / this month). The pill is the visible
 * control; a transparent real <select> covers it so iOS/Android open their
 * own picker. Purely presentational: the parent owns the selection and swaps
 * between the buckets crew.getById already returned, so changing it never
 * refetches.
 */
export function StatsPeriodSelect({ value, onChange, className }: StatsPeriodSelectProps) {
  const label = statsPeriodOptions.find((option) => option.value === value)?.label ?? ''
  return (
    <div className={cn('relative w-full', className)}>
      <Pill variant="draft" className="w-full justify-between">
        <Calendar />
        {label}
        <ChevronDown />
      </Pill>
      <NativeSelectOverlay
        value={value}
        onChange={onChange}
        options={statsPeriodOptions}
        ariaLabel="Stats period"
        className="rounded-full"
      />
    </div>
  )
}
